import { useMsal } from "@azure/msal-react";
import { Checkbox, DefaultButton, IPanelProps, IRenderFunction, Panel, PanelType, PrimaryButton, Separator, Spinner, SpinnerSize, Stack } from "@fluentui/react";
import { RootState } from "app/store";
import saveAs from "file-saver";
import { emitCustomEvent, fadeIn, panelButtonsStyles } from "global/Application";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { MsalTokenSource } from "global/DataSources/MsalTokenSource";
import { useState } from "react";
import { useSelector } from "react-redux";
import { IAdobeCampaignExtractPayload } from "./IAdobeCampaignExtractPayload";
import { IAdobeCampaignExtractProps } from "./IAdobeCampaignExtractProps";

const AdobeCampaignExtract: React.FunctionComponent<IAdobeCampaignExtractProps> = (props) => {

    const { instance } = useMsal();

    const [loading, setLoading] = useState<boolean>(false);

    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);
    const state = useSelector((state: RootState) => state);

    const [vm, setVM] = useState<IAdobeCampaignExtractPayload>({
        sftp: 'no',
        production: 'yes',
    });

    const onRenderBodyLoading = () => {
        return <Spinner
            label="Please wait..."
            ariaLive="assertive"
            labelPosition="right"
            size={SpinnerSize.large}
            styles={{
                root: { padding: '25px' }
            }}
        />;
    }
    
    const onRenderBody = () => {
        return <div className={fadeIn}>
            <Separator />

            <Stack tokens={{ childrenGap: '15px' }}>
                {loading &&
                    onRenderBodyLoading()
                }

                {!loading &&
                    <>
                        <Checkbox
                            label="Download result locally"
                            checked={true}
                            disabled
                        />

                        <Checkbox
                            label="SFTP (secure file transfer protocol) to endpoint"
                            checked={vm.sftp === 'yes'}
                            onChange={(event, checked) => {
                                setVM(t => { return { ...t, sftp: checked ? 'yes' : 'no' } });
                            }}
                        />
                    </>
                }

            </Stack>
        </div>;
    }

    const onRenderFooter: IRenderFunction<IPanelProps> = (contextProps, defaultRender) => {
        return <>
            <PrimaryButton text='Continue'
                styles={panelButtonsStyles}
                disabled={loading}
                onClick={async () => {
                    setLoading(true);

                    const response = dataSource.getAdobeCampaignExtract({
                        sftp: vm.sftp,
                        production: vm.production,
                    }, () => {
                        // TODO implement a progress status
                        console.log(Date.now())
                    });

                    response
                        .then(res => {
                            saveAs(res.blob, res.fileName);
                        })
                        .catch((reason) => {
                            // lets create a new one is payload is not providing one
                            emitCustomEvent({
                                eventType: 'globalException',
                                details: reason
                            });

                        })
                        .finally(() => {
                            setLoading(false);
                        });
                }}

            />
            <DefaultButton text='Cancel'
                styles={panelButtonsStyles}
                onClick={() => {
                    props.onDismiss?.();
                }}
            />
        </>;
    }

    return <Panel
        isOpen={props.isOpen}
        type={PanelType.medium}
        isLightDismiss={false}
        closeButtonAriaLabel="Close"
        headerText="Adobe Campaign Extract"
        onRenderFooterContent={onRenderFooter}
        isFooterAtBottom={true}
        onDismiss={props.onDismiss}
    >
        {onRenderBody()}
    </Panel>
}

export default AdobeCampaignExtract;